/**
 * Account field rules mirrored from the backend (`app/users/schemas.py`) for
 * instant feedback. Messages are error codes rendered via i18n `validation.*`.
 */
import { z } from 'zod';

export const PASSWORD_MIN_LENGTH = 12;

export const loginField = z.string().regex(/^[A-Za-z0-9][A-Za-z0-9_.-]{2,31}$/, 'LOGIN_INVALID');
export const emailField = z.email('EMAIL_INVALID').max(254, 'EMAIL_INVALID');
export const displayNameField = z.string().trim().min(1, 'REQUIRED').max(100, 'STRING_TOO_LONG');
export const bioField = z.string().max(1000, 'STRING_TOO_LONG');
export const newPasswordField = z
  .string()
  .min(PASSWORD_MIN_LENGTH, 'PASSWORD_TOO_SHORT')
  .max(128, 'PASSWORD_TOO_LONG')
  .regex(/^[\x20-\x7e]*$/, 'PASSWORD_INVALID_CHARACTERS');

/** The browser's IANA timezone (sent at registration; editable in Account). */
export function browserTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
}

/** All IANA timezones the browser knows (for the Account selector). */
export function supportedTimezones(current: string): string[] {
  const all =
    typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : [];
  return all.includes(current) ? all : [current, ...all];
}
